export abstract class BaseRepository {
  token?: string
  setToken(_token?: string) {
    this.token = _token
  }
}
